module.exports = __webpack_public_path__ + "static/img/banner.430e7e42.png";